var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.125 7.4292H18.7842C18.9212 7.42913 19.0551 7.47 19.1687 7.54656C19.2823 7.62312 19.3705 7.73188 19.4219 7.85889L20.625 10.8667",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.375 12.9292H15.125",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 19.1167C16.9516 19.1167 17.875 18.1933 17.875 17.0542C17.875 15.9151 16.9516 14.9917 15.8125 14.9917C14.6734 14.9917 13.75 15.9151 13.75 17.0542C13.75 18.1933 14.6734 19.1167 15.8125 19.1167Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 19.1167C7.32659 19.1167 8.25 18.1933 8.25 17.0542C8.25 15.9151 7.32659 14.9917 6.1875 14.9917C5.04841 14.9917 4.125 15.9151 4.125 17.0542C4.125 18.1933 5.04841 19.1167 6.1875 19.1167Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17.0542H8.25",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 10.8667H20.625V16.3667C20.625 16.549 20.5526 16.7239 20.4236 16.8528C20.2947 16.9818 20.1198 17.0542 19.9375 17.0542H17.875",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.125 17.0542H2.0625C1.88016 17.0542 1.7053 16.9818 1.57636 16.8528C1.44743 16.7239 1.375 16.549 1.375 16.3667V6.7417C1.375 6.55936 1.44743 6.38449 1.57636 6.25556C1.7053 6.12663 1.88016 6.0542 2.0625 6.0542H15.125V15.1094",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarTruck);
export default __webpack_public_path__ + "static/media/icon-sidebar-truck.a80e4e03e27fe55bb1b13fc9cea3863c.svg";
export { ForwardRef as ReactComponent };